import { useState, useEffect, useRef } from 'react';
import { maskCpfCnpj } from "../../utils/ValidationUtils";
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findClient from '../../service/findClient';
import { Button } from 'primereact/button';
import { SortOrder } from 'primereact/api';
import { Nullable } from 'primereact/ts-helpers';
import { InputText } from 'primereact/inputtext';
import React from 'react';
import { Toolbar } from 'primereact/toolbar';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import patchClientStatus from '../../service/patchClientStatus';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import './ClienteList.css';
import { InputSwitch } from 'primereact/inputswitch';
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import getClienteMotivosCancelamento from '../../service/getClienteMotivosCancelamento';
import postCancelarCliente from '../../service/postCancelarCliente';




export default function ClienteList({ onEdit }: { onEdit: (user: any) => void }) {
  const { t } = useTranslation();
  const [clients, setClients] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const [cliente, setCliente] = useState<Nullable<String | null>>(null);
  const [documento, setDocumento] = useState<Nullable<String | null>>(null);
  const { state } = useGlobalState();
  const toast = useRef<Toast>(null);

  const [cancelDialogVisible, setCancelDialogVisible] = useState(false);
  const [clienteCancelar, setClienteCancelar] = useState<any>(null);
  const [motivosCancelamento, setMotivosCancelamento] = useState<any[]>([]);
  const [selectedMotivo, setSelectedMotivo] = useState<any>(null);
  const [motivoError, setMotivoError] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [motivoDialogVisible, setMotivoDialogVisible] = useState(false);
  const [motivoVisualizar, setMotivoVisualizar] = useState<any>(null);
  const [codigoClienteErp, setCodigoClienteErp] = useState<Nullable<String | null>>(null);
  const [inativoDialogVisible, setInativoDialogVisible] = useState(false);
  const [clienteInativoVisualizar, setClienteInativoVisualizar] = useState<any>(null);

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    cliente: cliente,
    documento: documento,
    codigoClienteErp: codigoClienteErp,
    inativo: null,
    idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    sortField: 'nome',
    sortOrder: SortOrder.ASC,

  });

  const statusOptions = [
    { label: 'Todos', value: null },
    { label: 'Ativos', value: 'false' },
    { label: 'Inativos', value: 'true' },
    { label: 'Cancelados', value: 'canceled' }
  ];

  const changeStatus = (e: any) => {
    const value = typeof e.value === 'boolean' ? e.value.toString() : e.value;
    setlazyState({
      ...lazyState,
      inativo: value === 'true' || value === 'false' || value === 'canceled' ? value : null,
      first: 0,
      page: 1

    });
  }

  const changeDocumento = (doc: Nullable<String>) => {
    if (doc) {
      doc = doc ? doc.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '') : null
      setDocumento(doc);
      setlazyState({
        first: 0,
        rows: lazyState.rows,
        page: 1,
        cliente: cliente,
        documento: doc,
        codigoClienteErp: codigoClienteErp,
        inativo: lazyState.inativo,
        idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'nome',
        sortOrder: SortOrder.ASC,

      });
    }
  }

  const changeCliente = (cli: Nullable<String>) => {
    if (cli) {
      setCliente(cli);
      setlazyState({
        first: 0,
        rows: lazyState.rows,
        page: 1,
        cliente: cli,
        documento: documento,
        codigoClienteErp: codigoClienteErp,
        inativo: lazyState.inativo,
        idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'nome',
        sortOrder: SortOrder.ASC
      });
    }
  }

  const changeCodigoClienteErp = (codigo: Nullable<String>) => {
    if (codigo) {
      setCodigoClienteErp(codigo);
      setlazyState({
        first: 0,
        rows: lazyState.rows,
        page: 1,
        cliente: cliente,
        documento: documento,
        codigoClienteErp: codigo,
        inativo: lazyState.inativo,
        idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'nome',
        sortOrder: SortOrder.ASC
      });
    }
  }

  const handleDocumento = (event: any) => {
    event.target.value = maskCpfCnpj(event.target.value)
  }

  const cols = [
    { field: 'documento', header: 'Documento' },
    { field: 'nome', header: 'Nome' },
    { field: 'email', header: 'Email' },
    { field: 'inativo', header: 'Inativo' }
  ];
  const exportColumns = cols.map((col) => ({ title: col.header, dataKey: col.field }));
  const exportPdf = () => {
    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then(() => {
        const lazy = {
          first: 0,
          rows: totalRecords,
          page: 1,
          cliente: cliente,
          documento: documento,
          codigoClienteErp: codigoClienteErp,
          inativo: lazyState.inativo,
          idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
          sortField: 'nome',
          sortOrder: SortOrder.ASC
        }
        findClient(lazy).then(data => {
          const doc: any = new jsPDF.default('portrait');
          doc.autoTable(exportColumns, data.clientes);
          doc.save('clientes.pdf');
        });

      });
    });
  };

  const exportExcel = () => {
    import('xlsx').then((xlsx) => {
      const lazy = {
        first: 0,
        rows: totalRecords,
        page: 1,
        cliente: cliente,
        documento: documento,
        codigoClienteErp: codigoClienteErp,
        inativo: lazyState.inativo,
        idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'nome',
        sortOrder: SortOrder.ASC
      }
      findClient(lazy).then(data => {
        const users: any[] = []
        data.clientes.forEach((client: any) => users.push({ nome: client.nome, email: client.email, documento: client.documento, inativo: client.inativo }))

        const worksheet = xlsx.utils.json_to_sheet(users);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
        saveAsExcelFile(excelBuffer, 'clientes');
      });


    });
  };
  const saveAsExcelFile = (excelBuffer: any, fileName: string) => {
    import('file-saver').then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([excelBuffer], {
          type: EXCEL_TYPE
        });

        module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }
    });
  };

  const header = (
    <div className="flex-consulta align-items-center justify-content-end gap-2">
      <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
      <Button type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={exportPdf} data-pr-tooltip="PDF" />
    </div>
  );

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      cliente: cliente,
      documento: documento,
      codigoClienteErp: codigoClienteErp,
      inativo: lazyState.inativo,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event: any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      cliente: cliente,
      documento: documento,
      codigoClienteErp: codigoClienteErp,
      inativo: lazyState.inativo,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const statusBodyTemplate = (client:any) => {
     return <InputSwitch checked={client.inativo} value={client.inativo} disabled={client.cancelamento === true} onChange={() => { client.inativo = !client.inativo; saveStatusClient(client.id, client.inativo)}} />;
   };

  const cancelamentoBodyTemplate = (client: any) => {
    if (client.cancelamento === true) {
      const motivoResumo = client.motivoCancelamento
        ? String(client.motivoCancelamento).replaceAll('<br/>', ' ') + ' — clique para ver detalhes'
        : undefined;
      return (
        <Tag
          className={'cancelado-tag' + (client.motivoCancelamento ? ' cancelado-tag--clickable' : '')}
          icon="pi pi-ban"
          severity="danger"
          value="Cancelado"
          data-pr-tooltip={motivoResumo}
          onClick={() => client.motivoCancelamento && openMotivoDialog(client)}
        />
      );
    }
    if (client.inativo === true) {
      return (
        <Tag
          className="inativo-tag inativo-tag--clickable"
          icon="pi pi-pause-circle"
          severity="warning"
          value="Inativo"
          onClick={() => openInativoDialog(client)}
        />
      );
    }
    return <Tag className="ativo-tag" icon="pi pi-check-circle" severity="success" value="Ativo" />;
  };

  const loadLazyData = () => {
    findClient(lazyState).then(data => {
      setTotalRecords(data.total);
      let filteredClients = data.clientes;
      if (lazyState.inativo === 'true') {
        filteredClients = filteredClients.filter((c: any) => c.inativo === true);
      } else if (lazyState.inativo === 'false') {
        filteredClients = filteredClients.filter((c: any) => c.inativo === false || c.inativo === null || c.inativo === undefined);
      }
      setClients(filteredClients);
    }).catch(() => { setTotalRecords(0); setClients(undefined) });
  }

  const saveStatusClient = (id: string, inativo: boolean) => {
    patchClientStatus(id, inativo)
      .then(() => { loadLazyData(); toast.current!.show({ severity: 'success', summary: 'Sucesso', detail: 'Status alterado com sucesso', life: 3000 }); })
      .catch(() => { toast.current!.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao alterar status', life: 3000 }); });
  }

  const openCancelDialog = (client: any) => {
    setClienteCancelar(client);
    setSelectedMotivo(null);
    setMotivoError(false);
    setMotivosCancelamento([]);
    getClienteMotivosCancelamento().then((data) => {
      setMotivosCancelamento(data || []);
    });
    setCancelDialogVisible(true);
  };

  const closeCancelDialog = () => {
    if (cancelLoading) return;
    setCancelDialogVisible(false);
    setClienteCancelar(null);
    setSelectedMotivo(null);
    setMotivoError(false);
  };

  const handleCancelarCliente = () => {
    if (!selectedMotivo) {
      setMotivoError(true);
      return;
    }
    if (!clienteCancelar) return;
    setCancelLoading(true);
    postCancelarCliente({ id: clienteCancelar.id, motivoCancelamento: selectedMotivo })
      .then(() => {
        setCancelLoading(false);
        setCancelDialogVisible(false);
        setClienteCancelar(null);
        setSelectedMotivo(null);
        loadLazyData();
        toast.current!.show({ severity: 'success', summary: 'Cliente cancelado', detail: 'O cliente foi cancelado e as negativações ativas serão canceladas automaticamente.', life: 4000 });
      })
      .catch((error) => {
        setCancelLoading(false);
        const errorMessage = error?.message || (typeof error === 'string' ? error : 'Erro ao cancelar o cliente');
        toast.current!.show({ severity: 'error', summary: 'Erro ao cancelar', detail: errorMessage, life: 5000 });
      });
  };

  const openMotivoDialog = (client: any) => {
    setMotivoVisualizar(client);
    setMotivoDialogVisible(true);
  };

  const openInativoDialog = (client: any) => {
    setClienteInativoVisualizar(client);
    setInativoDialogVisible(true);
  };

  const formatDateHora = (date: any) => {
    if (!date) return '-';
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? '-' : parsed.toLocaleString('pt-BR');
  };

  const dataInclusaoBodyTemplate = (client: any) => {
    if (client.dataInclusao) {
      const date = new Date(client.dataInclusao);
      return date.toLocaleDateString('pt-BR');
    }
    return '-';
  };



  const redirectUsuarioPage = (clientFilter: any) => {
    localStorage.setItem('selectedClientUsuario', JSON.stringify(clientFilter));
    const url = `/creditbureau/usuario/`;
    window.open(url, '_blank');
  };

  const redirectSaldoClientePage = (clientFilter: any) => {
    const url = `/creditbureau/saldo-cliente/${clientFilter.id}`;
    window.open(url, '_blank');
  };

  const editBodyTemplate = (client: any) => {
    return <div style={{ display: 'flex' }}>
      {state.user.funcoes.includes('CLIENTE_CADASTRAR') && client.cancelamento !== true && <Button icon="pi pi-pencil" onClick={() => onEdit(client)} style={{ background: 'transparent', color: 'gray', border: 'none' }} /> }
      {state.user.funcoes.includes('USUARIO_VISUALIZAR') && <Button icon="pi pi-user" onClick={() => redirectUsuarioPage(client)} style={{ background: 'transparent', color: 'gray', border: 'none' }} />}
      {state.user.funcoes.includes('SALDO_CLIENTE_VISUALIZAR') && client.tipoFaturamento === 'PRE_PAGO' && <Button icon="pi pi-shopping-cart" onClick={() => redirectSaldoClientePage(client)} style={{ background: 'transparent', color: 'gray', border: 'none' }} />}
      {client.cancelamento !== true && <Button icon="pi pi-ban" tooltip="Cancelar cliente" tooltipOptions={{ position: 'top' }} onClick={() => openCancelDialog(client)} style={{ background: 'transparent', color: '#e24c4c', border: 'none' }} />}
    </div>;
  };

  const clearFields = () => {
    setCliente(null);
    setDocumento(null);
    setCodigoClienteErp(null);
    const clienteInput = document.getElementById('cliente') as HTMLInputElement;
    if (clienteInput) clienteInput.value = '';
    const documentoInput = document.getElementById('documento') as HTMLInputElement;
    if (documentoInput) documentoInput.value = '';
    const codigoClienteErpInput = document.getElementById('codigoClienteErp') as HTMLInputElement;
    if (codigoClienteErpInput) codigoClienteErpInput.value = '';
    setlazyState({
      ...lazyState,
      first: 0,
      page: 1,
      cliente: null,
      documento: null,
      codigoClienteErp: null,
      inativo: null,
      sortField: 'nome',
      sortOrder: SortOrder.ASC
    });
  };

  const startContent = (
    <div className="filtros">
      <div className="filtros-grid">
        <div className="filtros-item">
          <label htmlFor="cliente" className="font-bold">{t('nome')}</label>
          <InputText id="cliente" onBlur={(e) => changeCliente(e.target.value)} />
        </div>
        <div className="filtros-item">
          <label htmlFor="documento" className="font-bold">{t('documento')}</label>
          <InputText id="documento" maxLength={18} max={18} onKeyUp={handleDocumento} onBlur={(e) => changeDocumento(e.target.value)} />
        </div>
        <div className="filtros-item">
          <label htmlFor="status" className="font-bold">Status</label>
          <Dropdown inputId="status" value={lazyState.inativo} options={statusOptions} onChange={changeStatus} placeholder="Selecione um status" />
        </div>
        <div className="filtros-item">
          <label htmlFor="codigoClienteErp" className="font-bold">{t('codigoCliente')}</label>
          <InputText id="codigoClienteErp" onBlur={(e) => changeCodigoClienteErp(e.target.value)} />
        </div>
      </div>
      <div className="filtros-acoes">
        <Button label='Limpar' icon="pi pi-times" onClick={clearFields} className="button_remove_backgroung" outlined style={{ color: '#183462' }} />
      </div>
    </div>
  );

  useEffect(() => {
    loadLazyData();
  }, [lazyState])

  return (
    <div>
      <Toast ref={toast} />
      <div>
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <Tooltip target=".cancelado-tag" position="top" />
        <DataTable value={clients} first={lazyState.first} dataKey="id" paginator={true} lazy={true}
          emptyMessage="Sem registros" header={header}
          onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
          rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
          rowClassName={(data) => data.cancelamento ? 'cliente-canceled-row' : (data.inativo ? 'cliente-inactive-row' : '')}
          tableStyle={{ minWidth: '75rem' }}>
          <Column body={dataInclusaoBodyTemplate} sortable sortField='dataInclusao' header={t('dtInclusao')} />
          <Column field="documento" sortable header={t('documento')} />
          <Column field="nome" sortable header={t('nome')} />
          <Column field="email" sortable sortField='email' header={t('email')} />
          <Column field="responsavel" sortable sortField='responsavel' header={t('responsavel')} />
          <Column body={cancelamentoBodyTemplate} header="Status" />
          <Column body={statusBodyTemplate} header={t('inativo')} />
          <Column body={editBodyTemplate} />
        </DataTable>
      </div>

      <Dialog
        visible={cancelDialogVisible}
        onHide={closeCancelDialog}
        closable={!cancelLoading}
        showHeader={false}
        dismissableMask={!cancelLoading}
        className="cancel-client-dialog"
        style={{ width: '32rem' }}
        breakpoints={{ '640px': '95vw' }}
        contentClassName="cancel-client-content"
      >
        <div className="cancel-client-hero">
          <div className="cancel-client-hero-icon">
            <i className="pi pi-ban"></i>
          </div>
          <h2>Cancelar cliente</h2>
          {clienteCancelar && <p className="cancel-client-name">{clienteCancelar.nome}</p>}
        </div>

        <div className="cancel-client-body">
          <div className="cancel-client-alert">
            <i className="pi pi-exclamation-triangle"></i>
            <div>
              <strong>Esta ação não poderá ser desfeita.</strong>
              <span>O sistema irá cancelar automaticamente os registros de negativação ativos deste cliente.</span>
            </div>
          </div>

          <div className="cancel-client-field">
            <label htmlFor="motivoCancelamentoCliente">Motivo do cancelamento</label>
            <Dropdown
              id="motivoCancelamentoCliente"
              value={selectedMotivo}
              options={motivosCancelamento}
              onChange={(e) => { setSelectedMotivo(e.value); setMotivoError(false); }}
              placeholder="Selecione o motivo"
              className={'w-full' + (motivoError ? ' p-invalid' : '')}
              disabled={cancelLoading}
              emptyMessage="Nenhum motivo disponível"
            />
            {motivoError && <small className="p-error">Selecione um motivo para continuar.</small>}
          </div>
        </div>

        <div className="cancel-client-footer">
          <Button label="Voltar" severity="secondary" outlined onClick={closeCancelDialog} disabled={cancelLoading} />
          <Button label="Confirmar cancelamento" icon="pi pi-ban" severity="danger" onClick={handleCancelarCliente} loading={cancelLoading} />
        </div>
      </Dialog>

      <Dialog
        header="Detalhes do cancelamento"
        visible={motivoDialogVisible}
        onHide={() => setMotivoDialogVisible(false)}
        className="cancel-client-motivo-dialog"
        style={{ width: '28rem' }}
        breakpoints={{ '640px': '95vw' }}
      >
        {motivoVisualizar && (
          <div className="cancel-client-motivo-view">
            <div className="cancel-client-alert cancel-client-alert--info">
              <i className="pi pi-info-circle"></i>
              <span>Cliente <strong>{motivoVisualizar.nome}</strong> cancelado.</span>
            </div>
            <div className="cancel-client-meta">
              <div><strong>Data:</strong> {formatDateHora(motivoVisualizar.dataCancelamento)}</div>
              <div><strong>Usuário:</strong> {motivoVisualizar.usuarioCancelamento || '-'}</div>
            </div>
            <p className="cancel-client-motivo-text">
              {String(motivoVisualizar.motivoCancelamento).split('<br/>').map((texto: string, idx: number) => (
                <React.Fragment key={idx}><span>{texto}</span><br /></React.Fragment>
              ))}
            </p>
          </div>
        )}
      </Dialog>

      <Dialog
        header="Detalhes da inativação"
        visible={inativoDialogVisible}
        onHide={() => setInativoDialogVisible(false)}
        className="cancel-client-motivo-dialog"
        style={{ width: '28rem' }}
        breakpoints={{ '640px': '95vw' }}
      >
        {clienteInativoVisualizar && (
          <div className="cancel-client-motivo-view">
            <div className="cancel-client-alert cancel-client-alert--warning">
              <i className="pi pi-pause-circle"></i>
              <span>Cliente <strong>{clienteInativoVisualizar.nome}</strong> inativado.</span>
            </div>
            <div className="cancel-client-meta">
              <div><strong>Data:</strong> {formatDateHora(clienteInativoVisualizar.dataInativacao)}</div>
              <div><strong>Usuário:</strong> {clienteInativoVisualizar.usuarioInativacao || '-'}</div>
            </div>
          </div>
        )}
      </Dialog>
    </div>
  )
}


